import { render, staticRenderFns } from "./NewPatientForm.vue?vue&type=template&id=3665b01b&scoped=true"
import script from "./NewPatientForm.vue?vue&type=script&lang=js"
export * from "./NewPatientForm.vue?vue&type=script&lang=js"
import style0 from "./NewPatientForm.vue?vue&type=style&index=0&id=3665b01b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3665b01b",
  null
  
)

export default component.exports